import { format } from 'svelte-i18n';
import DevicePicker from '../Steps/DevicePicker.svelte';
import QuickActions from '../Steps/QuickActions.svelte';
import SelectMenu from '../Steps/SelectMenu.svelte';
import { get } from 'svelte/store';

export const trvTemplate = (disabled, deviceActions, windowReport, index) => {
	if (windowReport) {
		return [
			{
				active: index === 0,
				activeIndex: 0,
				disabled: disabled,
				showMoreDots: false,
				stepNumber: 1,
				title: get(format)('action_wizard_items_condition', {
					default: 'Condition',
				}),
				tooltipTitle: '',
				component: SelectMenu,
				validation: false,
			},
			{
				active: index === 1,
				activeIndex: 1,
				disabled: disabled,
				showMoreDots: false,
				stepNumber: 2,
				title: get(format)('devices', { default: 'Devices' }),
				tooltipTitle: '',
				component: DevicePicker,
				validation: false,
			},
			{
				active: index === 2,
				activeIndex: 2,
				component: QuickActions,
				disabled: deviceActions.disabled,
				showMoreDots: false,
				stepNumber: 3,
				title: get(format)('actions', { default: 'Actions' }),
				tooltipTitle: '',
				validation: deviceActions.selectedDevices.length === 0,
			},
		];
	} else {
		return [
			{
				active: index === 0,
				activeIndex: 0,
				disabled: disabled,
				showMoreDots: false,
				stepNumber: 1,
				title: 'Condition',
				tooltipTitle: '',
				component: SelectMenu,
				validation: false,
			},
			{
				active: index === 1,
				activeIndex: 1,
				disabled: disabled,
				showMoreDots: false,
				stepNumber: 2,
				title: 'Devices',
				tooltipTitle: '',
				component: DevicePicker,
				validation: deviceActions.selectedDevices.length === 0,
			},
		];
	}
};
